import React from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import './index.scss';

const IndexPage = ({data}) => (
    <div className="page">
      <section className="index">
        <Img className="close-up-containers"
             sizes={data.closeUpContainers.childImageSharp.sizes}
             alt="your-stuff-goes-here"/>
      </section>
      <section className="info">
        <h1>Secure Self Storage for Newquay and Cornwall</h1>
        <div className="list">
        <ul>
          <li>Need somewher to store you motorhome, caravan or boat?</li>
          <li>Struggling for space in your garage?</li>
          <li>Fancy going travelling?</li>
          <li>Business expanding and need more space?</li>
        </ul>
        </div>
        <div className="words">
          <p>Whether you need short term or longterm storage, securely storing your belongings with Coastal Self Storage is exactly what you’re looking for.</p>
          <p>Centrally located between Newquay, Truro, Bodmin, Wadebridge and just minutes from the A30, this storage site couldn’t be more convenient.</p>
          <p>Whatever your needs we can offer storage services to suit you on a flexible or longterm basis, just call or email for more information.</p>

          <p>Just Give us a call on <a className="tel" href="tel:07483042210">07483 042 210</a></p>
        </div>
      </section>
    </div>
);


export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js